import { RadioGroupField, Select } from '@payaca/ambrosia';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const SelectFieldInput: FC<FieldProps<'select'>> = (props) => {
  const { definition, value, onChange } = props;

  if (definition.displayMode === 'radio') {
    const radioOptions =
      definition.options
        ?.filter((x): x is string => x !== null)
        .map((x) => ({
          value: x,
          label: x || '-',
        })) || [];

    return (
      <RadioGroupField
        value={value ?? undefined}
        options={radioOptions}
        hiddenInput
        emphasised
        onChange={(value: string) => {
          onChange(value);
        }}
      />
    );
  }

  return (
    <Select
      value={value ?? ''}
      options={
        definition.options?.map((x) => ({
          value: x,
          label: x || '-',
        })) || []
      }
      multiple={false}
      onChange={(value) => {
        onChange(value);
      }}
    />
  );
};
